// smooth scroll
jQuery(function($) {
  // var _urlHash = location.hash;
  // if(_urlHash) {
  //   $('body, html').stop().scrollTop(0);
  //   window.addEventListener('load', function() {
  //     var $target = $(_urlHash);
  //     var $position = $target.offset().top;
  //     $('body, html').stop().animate({
  //       scrollTop: $position - 90 + 'px'
  //     }, 800, 'swing');
  //   }, false);
  // }
  $('a[href^="#"]').on('click', function() {
    if ($(this).attr('data-killsmooth') !== 'true') {
      var $href = $(this).attr('href');
      var $target = $($href === '#' || $href === '' ? 'html' : $href);
      var $position = $target.offset().top;
      if ($href === '#' || $href === '') {
        if ($(this).attr('id') === 'js-go-to-top') {
          $('html, body').animate({
            scrollTop: $position
          }, 800, 'swing');
        } else {
          return false;
        }
      } else {
        $('html, body').animate({
          scrollTop: $position - 80 + 'px'
        }, 800, 'swing');
        return false;
      }
    }
  });
});
